var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-forum-layout',{staticClass:"edit-post",attrs:{"searchbar":false}},[_c('r-forum-table',[_c('template',{slot:"title"},[_vm._v(" Edit post ")]),_c('template',{slot:"contents"},[(_vm.post)?_c('r-post-form',{attrs:{"post":_vm.post},on:{"success":_vm.success}}):_vm._e()],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }